import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { PageStructure } from '../types/pageStructure';

import * as pageStructure from '../../assets/general/pageStructure.json';


@Component({
  selector: 'app-general-pages',
  templateUrl: './general-pages.component.html',
  styleUrls: ['./general-pages.component.css']
})
export class GeneralPagesComponent implements OnInit {

  private actualPage: string;

  public pageContent: PageStructure;
  public carouselData = Array();
  public carouselTitle = '';
  public highlightImage = true;

  private pages: PageStructure[] = Array();

  constructor(private route: ActivatedRoute) {

    this.actualPage = this.route.snapshot.routeConfig.path;

    // Hack to move to top page when clicked on a pest
    if (this.actualPage.split('/')[0]) {
      if (this.actualPage.split('/')[0] === 'pests' && this.actualPage.split('/').length > 1) {
        window.scroll(0, 0);
      }
    }

    if (this.actualPage.split('/')[1]) {
      this.actualPage = this.actualPage.split('/')[1];
    }

  }

  public loadCarousel(itemTitle, carouselData) {
    this.carouselTitle = this.pageContent.title + ' - ' + itemTitle;
    this.carouselData = carouselData;
  }

  ngOnInit() {

    this.pages = (<any>pageStructure).pages;

    const selectedPage = this.pages;

    selectedPage.forEach(element => {

      if (element.page === this.actualPage) {
        this.pageContent = element;
      }
    });

  }

}
